export const defaultPrimaryColors = {
  action: "#000000",
  addButton: "#148e2a",
  additionalInfo: "#148e2a",
  background: "#ffffff",
  button: "#2c3070",
  buttonText: "#ffffff",
  cartBackground: "#ffffff",
  cartBadge: "#b30000",
  cartBorders: "#012659",
  cartIconBackground: "#ffffff",
  cartIconEmpty: "#012659",
  cartIconFilled: "#528d36",
  dateRangeBg: "#ffffff",
  dateRangeBgComplete: "#148e2a",
  dateRangeBgFrom: "#0454c2",
  dateRangeBgTo: "#012659",
  dateRangeTitle: "#000000",
  decButton: "#2c3070",
  dialogBackground: "#ffffff",
  divider: "#ffffff",
  extraFields: "#808080",
  filterOption: "#808080",
  filterSelected: "#012659",
  icon: "#012659",
  iconBg: "#2b6777",
  main: "#012659",
  mainText: "#000000",
  mobileStepper: "rgba(0,0,0,0.85)",
  mobileStepperProgress: "#528d36",
  productCardBg: "transparent",
  providerSelectBg: "#ffffff",
  qtyBackground: "#F4F4F4",
  rescheduleAlertBg: "##e8f4fd",
  reservedButtonColor: "#528d36",
  secondaryText: "#ffffff",
  serviceProviderBg: "transparent",
  stepperActiveText: "rgba(0,0,0,0.90)",
  stepperActiveValue: "#ffffff",
  stepperBg: "transparent",
  stepperBgActive: "transparent",
  stepperCompleted: "#ffffff",
  stepperInactiveAvatar: "#d9d9d9",
  stepperInactiveText: "rgba(0,0,0,0.45)",
  stepperInactiveValue: "rgba(0,0,0,0.45)",
  stepperText: "#ffffff",
  totalPrice: "#012659",
  noImageIcon: "#012659",
};

export const defaultSecondaryColors = {
  main: "#528d36",
  reservedButtonColor: "#012659",
  stepper: "#b6b6b6",
  stepperText: "#000000",
  stepperIndicatorText: "#ffffff",
  background: "#ffffff",
  filterBackground: "#efefefef",
  text: "#808080",
  serviceProviderBg: "#f7f7f7",
};
